<template lang="pug">
table(class="table table--striped table--form business-rules-table" data-test-id="business-rules-table")
  thead
    th Order
    th Name
    th Rule
    th Resources
    th
  draggable(tag="tbody" :list="businessRules" id="business-rules" handle=".handle" v-bind="dragOptions" @end="reorder" )
    BusinessRuleRow(
      v-for="businessRule in businessRules"
      v-if="shouldBusinessRuleBeVisible(businessRule.inPast)"
      :activitiesLookup="activitiesLookup"
      :businessRule="businessRule" 
      :scheduleKeys="scheduleKeys"
      :rulesForThisDay="rulesForThisDay"
      :key="businessRule.Key")
</template>

<script>
import BusinessRuleRow from './BusinessRuleRow.vue'
import draggable from 'vuedraggable'

export default {
  name: 'BusinessRulesTable',
  components: { BusinessRuleRow, draggable },
  props: {
    businessRules: Array,
    activitiesLookup: Array,
    scheduleKeys: Array,
    hideRulesFromThePast: Boolean,
    rulesForThisDay: Boolean,
  },
  data() {
    return {
      dragging: false,
      dragOptions: {
        animation: 200,
        group: 'description',
        disabled: !this.hideRulesFromThePast,
      },
    }
  },
  computed: {
    businessRulesFiltered() {
      return this.businessRules.filter(businessRule => {
        return this.hideRulesFromThePast ? businessRule.inPast === false : businessRule
      })
    },
  },
  methods: {
    shouldBusinessRuleBeVisible(inPast) {
      return this.hideRulesFromThePast ? inPast === false : true
    },
    reorder() {
      if (this.hideRulesFromThePast) {
        const businessRulesLength = this.businessRules.length

        this.businessRules.forEach((businessRule, indx) => {
          businessRule.Priority = businessRulesLength - indx - 1
        })

        this.$bus.$emit('reorder-business-rules', 'reorder')
      }
    },
  },
}
</script>

<style scoped lang="stylus">
// This styling is important for the drag and drop,
// Because a table row conforms to table layout, but not while it's being dragged.
.business-rules-table {
  background: #fff;
  color: #2c333a;
  border-radius: 3px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
  border: solid 1px #ececec;
  padding: 30px 0;
  margin-bottom: 30px;

  tr {
    background: white;
  }

  th {
    padding-top: 35px
  }

  td:nth-child(1),
  th:nth-child(1) {
    min-width: 3px;
    width: 3%;
    max-width: 3%;
  }

  td:nth-child(2),
  th:nth-child(2) {
    width: 39%;
    max-width: 39%;
  }


  td:nth-child(3),
  th:nth-child(3) {
    width: 25%;
    max-width: 25%;
  }

  td:nth-child(4),
  th:nth-child(4) {
    width: 25%;
    max-width: 25%;
  }

  td:nth-child(5),
  th:nth-child(5) {
    width: 8%;
    max-width: 8%;
    min-width: 8%;
  }
}
</style>
